<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold Select document type
      v-spacer
      v-btn(icon color="neutral700" @click="closeDialog")
        v-icon mdi-close
    v-divider

    v-card-text.py-6.px-10
      .text-sm.mb-4 Choose a document to create and proceed
      v-card.pa-4.rounded-lg.hover-bg.mb-3(v-for="selection in selectionItems" :key="selection.title" :class="[{ 'selected': isSelected(selection) }]" outlined @click="handleSelectedItem(selection)")
        .text-md.font-semibold {{ selection.title }}
        .text-sm.neutral500--text {{ selection.description }}

    v-card-actions.pa-0.white
      .d-flex.flex-column(style="width:100%")
        v-divider.mb-2
        .d-flex.align-center.justify-end.px-4.py-2
          v-btn.button-md.neutral700--text.px-0.underline.mr-2(text @click="closeDialog") {{ $t('cancel') }}
          v-btn.button-md.white--text.neutral700(:loading="loading" depressed :disabled="!canProceed" @click="handleNext") Next
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    },
    loading: {
      type: Boolean
    },
    title: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedItem: null
    }
  },
  computed: {
    ...mapGetters({ isHq: 'hq/getIsHq', company: 'getCompany' }),
    selectionItems() {
      const items = [
        {
          id: 'quotation',
          title: 'Request for quotation (RFQ)',
          description: 'Draft from inventory & send request to supplier'
        },
        {
          id: 'purchase-order',
          title: 'Purchase order',
          description: 'Manage payments, adjust supplier rates & auto-update received stock'
        },
        {
          id: 'invoice',
          title: 'Invoice',
          description: 'Track payment progress & auto-update stocks received'
        },
      ]
      // TODO: Re-enable Stock transfer option in Create new dialog when feature is ready
      // if (this.isHq || !!this.company?.branch_of) {
      //   items.splice(1, 0, {
      //     id: 'stock-transfer',
      //     title: 'Request stock from HQ or branch',
      //     description: 'Create & send stock transfer request to HQ or branch'
      //   })
      // }
      return items
    },
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    canProceed () {
      return !!this.selectedItem
    }
  },
  methods: {
    closeDialog () {
      this.$emit('cancel')
      this.showDialog = false
    },
    handleSelectedItem (selection) {
      this.selectedItem = selection
    },
    isSelected (selection) {
      return this.selectedItem?.id === selection.id
    },
    handleNext () {
      this.$emit('selected', this.selectedItem)
    }
  },
}
</script>

<style scoped>
.selected {
  border-color: var(--v-info500);
}
</style>